import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=311c4994&scoped=true&"
import script from "./NsFooter.vue?vue&type=script&lang=js&"
export * from "./NsFooter.vue?vue&type=script&lang=js&"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=311c4994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c4994",
  null
  
)

export default component.exports